// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Modal_Backdrop__2KkBT","modal":"Modal_modal__P_MCv","slide-down":"Modal_slide-down__mz9_z"};